import { HttpClient } from '@angular/common/http';
import { ParseError } from '@angular/compiler';
import { Component, Inject, booleanAttribute } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api.service';
import { CartService } from 'src/app/shared/services/cart.service';

@Component({
    selector: 'molla-vivasuccess',
    templateUrl: './vivasuccess.component.html',
    styleUrls: ['./vivasuccess.component.scss'],
    standalone: false
})


export class VivasuccessComponent {
  constructor(public  apiService:ApiService, public cartService:CartService, @Inject(Router) public router:Router,@Inject(ActivatedRoute) 
  private activatedRoute: ActivatedRoute,  private httpClient: HttpClient){
  }

  public cartItems:any;
  public priceTotal:any;
  public notes:string;
  public paymentid:string;
  public dbResolver:any;
  public pendingOrderId:string;
  public confirmSessionKey:string;

  async ngOnInit(): Promise<void> {
    try {                    
      if(typeof window !== 'undefined'){
        await this.apiService.fetchDBconnStringPromise();
        await this.apiService.storeParams();
      }

      if (typeof window !== 'undefined') 
        if(!this.apiService.shippingId){
          this.apiService.shippingId = JSON.parse(localStorage.getItem('shipping_id'));
          this.apiService.shippingDesc = JSON.parse(localStorage.getItem('shipping_description'));
          this.apiService.shippingCost = JSON.parse(localStorage.getItem('shipping_cost'));
          this.apiService.redeemPoints = JSON.parse(localStorage.getItem('redeemPoints'));
        }

      
      // Note: Below 'queryParams' can be replaced with 'params' depending on your requirements
      this.activatedRoute.queryParams.subscribe(params => {
        this.paymentid = params['s'];      
      });
      
      this.readPaymentDetails();
      let vivaCodeisDuplicated = await lastValueFrom(this.apiService.getVivaCodeDuplicated(this.paymentid));
      vivaCodeisDuplicated = JSON.parse(vivaCodeisDuplicated);
      this.confirmSessionKey = 'vivaConfirmed_' + (this.pendingOrderId || '') + '_' + (this.paymentid || '');
      const pageAlreadyProcessed = sessionStorage.getItem(this.confirmSessionKey) === 'true';
      if(!pageAlreadyProcessed &&  !vivaCodeisDuplicated){      
        if(this.paymentid && this.paymentid.length>1 && this.pendingOrderId){
          await this.confirmPayment();
          sessionStorage.setItem(this.confirmSessionKey, 'true');
        }    
        else{
          this.apiService.popupMsg("Something went wrong!","Missing order or payment id","error");         
        }  
      }
      else{
        this.apiService.popupMsg("Order already send successfully!","You can now navigate to home page. ","info");
      }
        
    } catch (error) {              
       await lastValueFrom(this.apiService.logError(error, this.router.url));
	} finally {
	  this.apiService.endOnlinePaymentAttempt('VivaWallet');
    }
        
  }

  async confirmPayment(){
    try {
      let res:any = await lastValueFrom(this.apiService.confirmOnlineOrderPaymentPromise(this.pendingOrderId, this.paymentid, "VivaWallet"));
      let confirmRes:any = typeof res === 'string' ? JSON.parse(res) : res;
    if(!confirmRes || !confirmRes.success)
    {
      this.apiService.popupMsg("Something went wrong!","Order payment was not confirmed. Contact the shop.","error");
    }
    else{
      //clear cart
      if(this.cartItems && this.cartItems.length > 0){
        await this.apiService.createOrderPdf(this.pendingOrderId);
        //await lastValueFrom(this.apiService.sendEmailCompany(this.cartItems));
        //await lastValueFrom(this.apiService.sendCustomerConfirmationEmail(this.cartItems));
      }
      if(this.cartItems && this.cartItems.length > 0){
        this.cartItems.forEach(item =>{
          this.cartService.removeFromCart(item);
        });
      }
      if(typeof window !== 'undefined'){
        localStorage.removeItem('pendingOrderId');
        localStorage.removeItem('pendingProvider');
        localStorage.removeItem('pendingFingerprint');
        localStorage.removeItem('pendingCheckoutToken');
        localStorage.removeItem('onlinepaymentcode');
      }
      this.apiService.popupMsg("Congrats!","Completed successfully","info");
    }
      
    } catch (error) {
      await lastValueFrom(this.apiService.logError(error, this.router.url));
    }
  }	

  async readPaymentDetails(){
    try {
      if (typeof window !== 'undefined') {
        this.cartItems = JSON.parse(localStorage.getItem('cartItems'));
        this.priceTotal = JSON.parse(localStorage.getItem('totalPrice'));
        this.notes = JSON.parse(localStorage.getItem('orderNotes'));
        this.pendingOrderId = JSON.parse(localStorage.getItem('pendingOrderId'));
      }
      //this.paymentid = localStorage.getItem(JSON.parse('onlinepaymentcode'));    
      //console.log(JSON.stringify(this.cartItems) + " " +this.priceTotal+ " " +this.notes+ " " +this.paymentid + " redeemPoints: " + this.apiService.redeemPoints);      
    } catch (error) {
      await lastValueFrom(this.apiService.logError(error, this.router.url));
    }    
  } 

}
